import { ShieldCheck } from "lucide-react";
import { SalesforceReleaseLayout } from "@/components/organisms/salesforce-release/SalesforceReleaseLayout";
import { PageHeader } from "@/components/molecules/PageHeader";

export function SalesforceReleasesPage() {

  return (
    <div className="flex h-full flex-col gap-4 animate-fade-in">
      <PageHeader icon={ShieldCheck} title="Salesforce Releases" description="Upload a release notes PDF — cross-referenced against your org's metadata and code" />

      <div className="flex-1 min-h-0 overflow-y-auto">
        <SalesforceReleaseLayout />
      </div>
    </div>
  );
}

export default SalesforceReleasesPage;
